import { render } from "./UserManageIcon.vue?vue&type=template&id=28fd6b59"
import script from "./UserManageIcon.vue?vue&type=script&lang=js"
export * from "./UserManageIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UserManageIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28fd6b59"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28fd6b59', __exports__)) {
    api.reload('28fd6b59', __exports__)
  }
  
  module.hot.accept("./UserManageIcon.vue?vue&type=template&id=28fd6b59", () => {
    api.rerender('28fd6b59', render)
  })

}


export default __exports__